import type { ReactElement } from "react";
import { orNotProvided } from "@/lib/display";

// One read-only fact in a quote's details (BRK-S347). A <dt>/<dd> pair, so it
// sits in the caller's <dl>. The WC wizard shows its values in field boxes
// instead, as its fields show them (`ReadOnlyField`, BRK-S349).
export function Fact({
  label,
  value,
  identifier = false,
}: {
  label: string;
  value: string | ReactElement | undefined;
  identifier?: boolean;
}) {
  return (
    <div className="min-w-0">
      <dt className="text-xs text-brk-dim">{label}</dt>
      <dd
        className={`break-words text-brk-text${identifier ? " tabular-nums" : ""}`}
      >
        {typeof value === "object" ? value : orNotProvided(value)}
      </dd>
    </div>
  );
}
